import script from "./Batches.vue?vue&type=script&setup=true&lang=js"
export * from "./Batches.vue?vue&type=script&setup=true&lang=js"

import "./Batches.vue?vue&type=style&index=0&id=5a38ae25&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a38ae25"]])

export default __exports__